

class Cart {
    constructor() {
        this.cartDrawerContent = document.querySelector('.cartpage_items_container')
        this.dscSubtotalPrice = document.querySelector('.cartpage_total_dsc_price')
        this.subtotalPrice = document.querySelector('.cartpage_subtotal_price')
        this.upsellItemsContainer = document.querySelector('.cartPage_upsell_items_container')
        this.upsellHeader = document.querySelector('.cartPage_upsell_header')
        this.checkoutBtn = document.querySelector('#cartPageCheckout')
        this.dscProgressBarFg = document.querySelector('.cartPage_dsc_progress_bar_fg')
        this.progressRewardsPrice = '.cartPage__progress_price'
        this.progressRewardsLabel = '.cartPage_progress_rewards'
        this.progressRewardsTickTextContainer = '.cartPage_progress_bar_tick_text_container'
        this.itemWrapper = '.cartPage-item__info-wrapper'
        this.removeIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20"><path d="M15.89 14.696l-4.734-4.734 4.717-4.717c.4-.4.37-1.085-.03-1.485s-1.085-.43-1.485-.03L9.641 8.447 4.97 3.776c-.4-.4-1.085-.37-1.485.03s-.43 1.085-.03 1.485l4.671 4.671-4.688 4.688c-.4.4-.37 1.085.03 1.485s1.085.43 1.485.03l4.688-4.687 4.734 4.734c.4.4 1.085.37 1.485-.03s.43-1.085.03-1.485z"></path></svg>'
        this.moneyFormat = "${{amount}}"
        this.itemQuantityPlus = '.js-cartpage-quantity-plus'
        this.itemQuantityMinus = '.js-cartpage-quantity-minus'
        this.itemQuantity = '.js-cartpage-quantity'
        this.removeItem = '.js-cartpage-remove-from-cart'
        this.cart_total_price = 0
        this.cart_total_qty = 0
        this.is_subscribed = false
        this.discounts = []
        // this.upsell_items_handles = ['perfect-probiotics', 'perfect-wild-alaskan-salmon-oil', 'perfect-digestion', 'perfect-immunity'];
        this.upsell_items_handles = ['perfect-probiotics', 'perfect-digestion', 'perfect-immunity','perfect-yumsauce'];
        this.upsell_items = []
        this.init()
    }

    init() {
        this.loadUpsellItems()
        this.fetchCartPage()
    }

    loadUpsellItems() {
        var cart = this
        this.upsell_items_handles.forEach(function (i) {
            window.fetch(`/products/${i}.js`, {
                credentials: "same-origin",
                method: "GET"
            }).then((response) => response.json()).then(function (data) { cart.upsell_items.push(data); cart.fetchCartPage() })
        })

    }

    addItemToCart(var_id, qty, selling_plan = null) {
        var cart = this
        window.fetch("/cart/add.js", {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                id: var_id,
                quantity: qty,
                selling_plan: selling_plan
            })
        }).then((function (t) {
            return t.json()
        })).then((function (result) {
            return cart.fetchCartPage()
        })).catch((function (t) {
            console.log("ERROR", t)
            // throw e.ajaxRequestFail(), new Error(t)
        }))
    }
    updateItemQty(var_id, qty) {
        var cart = this
        window.fetch("/cart/change.js", {
            method: "POST",
            credentials: "same-origin",
            body: JSON.stringify({
                id: var_id,
                quantity: qty
            }),
            headers: {
                "Content-Type": "application/json"
            }
        }).then((function (t) {
            return t.json()
        })).then((function (result) {
            return cart.renderCartPage(result)
        })).catch((function (t) {
            console.log("ERROR", t)
            // throw cart.ajaxRequestFail(), new Error(t)
        }))
    }

    fetchCartPage() {
        var e = this;
        window.fetch("/cart.js", {
            credentials: "same-origin",
            method: "GET"
        }).then((function (t) {
            return t.json()
        })).then((function (r) {
            return e.renderCartPage(r)
        })).catch((function (t) {
            console.log("ERROR", t)
            // throw e.ajaxRequestFail(), new Error(t)
        }))
    }

    renderCartPage(cart_obj) {
        this.clearCart()
        var cart = this
        const max_dsc = 320
        var pks = cart_obj ? cart_obj.items.filter(i => i.product_id == 7847669956826) : []
        var shortlisted_upsell_items = [...this.upsell_items_handles]

        this.cart_total_price = cart_obj.original_total_price / 100
        var slider_pct = (this.cart_total_price / max_dsc) * 100
        jQuery(cart.dscProgressBarFg).css('width', `${slider_pct}%`)
        jQuery(this.progressRewardsPrice).each(function (idx) {
            if (cart.cart_total_price >= idx * 80) {
                jQuery(this).addClass('active')
                jQuery(`${cart.progressRewardsLabel}:eq(${idx})`).addClass('active')
                jQuery(`${cart.progressRewardsTickTextContainer}:eq(${idx})`).addClass('active')
            }
            else {
                jQuery(this).removeClass('active')
                jQuery(`${cart.progressRewardsLabel}:eq(${idx})`).removeClass('active')
                jQuery(`${cart.progressRewardsTickTextContainer}:eq(${idx})`).removeClass('active')
            }
        })

        this.is_subscribed = ((window.sessionStorage.getItem('is_subscribed') === 'true') && pks && pks[0].quantity >= 3);
        this.getDiscounts()




        for (var i of cart_obj.items) {
            if (shortlisted_upsell_items.includes(i.handle)) {
                shortlisted_upsell_items.splice(shortlisted_upsell_items.indexOf(i.handle), 1)
            }
            cart.addCartItem(i)
          }
        document.querySelectorAll(this.itemQuantityMinus).forEach((function (t) {
            var isSample = jQuery(t).attr('class').includes('js-samples-watcher')
            var item_key = t.closest(cart.itemWrapper).getAttribute('data-key')
            if (!isSample){
              t.addEventListener("click", (function () {               
                  var current_qty = jQuery(this).siblings(cart.itemQuantity).val()
                  cart.updateItemQty(item_key, parseInt(current_qty) - 1)
              }))
            }
        }))
        document.querySelectorAll(this.itemQuantityPlus).forEach((function (t) {
            var isSample = jQuery(t).attr('class').includes('js-samples-watcher')
            var item_key = t.closest(cart.itemWrapper).getAttribute('data-key') 
            if (!isSample){
              t.addEventListener("click", (function () {
                  var current_qty = jQuery(this).siblings(cart.itemQuantity).val()
                  cart.updateItemQty(item_key, parseInt(current_qty) + 1)
              }))
            }
        }))
        document.querySelectorAll(this.removeItem).forEach((function (t) {
            var item_key = t.closest(cart.itemWrapper).getAttribute('data-key')
            t.addEventListener("click", (function () {
                cart.updateItemQty(item_key, 0)
            }))
        }))
        if (shortlisted_upsell_items.length > 0 && this.upsell_items.length > 0) {
            var upsell_header = `<img class="go_cart_drawer_upsell_header_img"
                                    src="https://cdn.shopify.com/s/files/1/0317/2827/1419/files/enhance.svg?v=1670956390"
                                    loading="lazy">
                                <h3 class="go_cart_drawer_upsell_header_txt">Your Dog's Health</h3>`
            this.upsellHeader.innerHTML += upsell_header
        }
        else {
            this.upsellHeader.innerHTML = ""
        }
        for (var u of this.upsell_items) {
            if (shortlisted_upsell_items.includes(u.handle)) {
                var upsell_item = `<div class="go_cart_drawer_upsell_item" data-id=${u.variants[0].id}>
                                    <div class="go_cart_drawer_upsell_item_img"
                                        style="background-image: url(${u.featured_image});"></div>
                                    <div class="go_cart_drawer_upsell_item_info">
                    <div class="go_cart_drawer_upsell_item_name">${u.title}</div>
                    <div class="go_cart_drawer_upsell_item_desc">${u.description}</div>
                    <div class="go_cart_drawer_upsell_item_price">
                        <span class="go_cart_drawer_upsell_item_actual_price">${cart.formatMoney(u.variants[0].selling_plan_allocations[0].price, cart.moneyFormat)}</span>
                        <span class="go_cart_drawer_upsell_item_base_price">${cart.formatMoney(u.price, cart.moneyFormat)}</span>
                    </div>
                </div>
                <div class="go_cart_drawer_upsell_item_add_btn_container">                                    
                    <button class="go_cart_drawer_upsell_item_add_btn_wrapper js_cartpage_upsell_item_add" data-product-id=${u.id}>+ Add</button>
                </div>
            </div>`
                this.upsellItemsContainer.innerHTML += upsell_item
            }
        }

        document.querySelectorAll('.js_cartpage_upsell_item_add').forEach((function (t) {
            t.addEventListener("click", (function () {
                const rtxn_app_id = "5859381"
                var id = t.getAttribute('data-product-id')
                var u_item = cart.upsell_items.find(i => i.id === parseInt(id))
                var sp_groups = u_item.selling_plan_groups.filter(i => i.app_id === rtxn_app_id)
                var sp_id = null
                if (sp_groups) {
                    sp_id = sp_groups[0].selling_plans[0].id
                }
                cart.addItemToCart(u_item.variants[0].id, 1, sp_id)

            }))
        }))


        var subtotal = cart_obj.original_total_price
        var dsc_subtotal = cart_obj.original_total_price * (1 - Math.round(this.calcDiscounts().value) / 100)
        this.subtotalPrice.innerHTML = subtotal === dsc_subtotal ? '' : this.formatMoney(subtotal, this.moneyFormat)
        this.dscSubtotalPrice.innerHTML = this.formatMoney(subtotal === dsc_subtotal ? subtotal : dsc_subtotal, this.moneyFormat)
        jQuery(this.checkoutBtn).prop("onclick", null).on("click", function () {
            window.location.href = `/checkout?discount=${cart.calcDiscounts().code}`
        })

        goCart.fetchCart()
        return ""
    }

    clearCart() {
        this.cartDrawerContent.innerHTML = ""
        this.upsellItemsContainer.innerHTML = ""
        this.upsellHeader.innerHTML = ""
    }

    addCartItem(item_obj) {       
        var recipe_txt = item_obj.options_with_values[0].value != 'Default Title' ? `${item_obj.options_with_values[0].value} recipe |` : ''
        var sp_txt = item_obj.hasOwnProperty('selling_plan_allocation') ? `Subscription | ${item_obj.selling_plan_allocation.selling_plan.name}` : "One-time purchase"
        var item_total_dsc_price = item_obj.original_line_price * (1 - Math.round(this.calcDiscounts().value) / 100)
        var orig_item_price = item_obj.original_line_price === item_total_dsc_price ? 0 : item_obj.original_line_price
        var item_extra_dsc_price = this.discounts.length > 1 ? item_obj.original_line_price * (1 - Math.round(this.discounts[0].value) / 100) : 0
        if (item_obj.handle.includes('sampler')){            
           var qty_input_selector = `
            <span class="go-cart-item__quantity-button minus ${this.itemQuantityMinus.replace('.', '')} js-samples-watcher-minus" disabled> - </span> 
            <input class="go-cart-item__quantity-number ${this.itemQuantity.replace('.', '')} js-samples-watcher-input" type="number" value="${item_obj.quantity}"  min="0" pattern="[0-9]*" max="1" disabled>
            <span class="go-cart-item__quantity-button plus ${this.itemQuantityPlus.replace('.', '')} js-samples-watcher-plus" disabled> +</span>`
        }
        else{            
          var qty_input_selector = `
          <span class="go-cart-item__quantity-button minus ${this.itemQuantityMinus.replace('.', '')}"> - </span>             
          <input class="go-cart-item__quantity-number ${this.itemQuantity.replace('.', '')}" type="number" value="${item_obj.quantity}">
          <span class="go-cart-item__quantity-button plus ${this.itemQuantityPlus.replace('.', '')}"> +</span>`            
        }
        var o = `<div class="${this.itemWrapper.replace('.', '')}" data-key=${item_obj.key}>
                    <div>
                        <a href="${item_obj.url}">
                            <div class="go-cart-item__image" style="background-image: url(${item_obj.image});"></div>
                        </a>
                    </div>
                    <div class="go-cart-item__info">
                    <div class="go_cart_item_info_container">
                        <a href="${item_obj.url}" class="go-cart-item_title">${item_obj.product_title}</a>
                        <a class="go-cart-item__remove js-cartpage-remove-from-cart">${this.removeIcon}</a>
                    </div>
                    <div class="go_cart_item_variant_txts_container">${recipe_txt} ${sp_txt}</div>
                    <div class="go-cart-item__variant"></div>
                    <div class="go-cart-item__quantity">
                        <div class="go_cart_item_qty_selector_container">
                            <span class="go-cart-item__quantity-label"></span>                                          
                            ${qty_input_selector}                            
                        </div>
                        <div>
                            <span class="go-cart-item__dsc_price cartpage-item_orig_price">${orig_item_price === 0 ? '' : this.formatMoney(orig_item_price, this.moneyFormat)}</span>
                            <span class="go-cart-item__dsc_price cartpage-item_extra_dsc_price">${item_extra_dsc_price === 0 ? '' : this.formatMoney(item_extra_dsc_price, this.moneyFormat)}</span>
                            <span class="go-cart-item__price cartpage-item_total_dsc_price">${this.formatMoney(item_total_dsc_price, this.moneyFormat)}</span>
                        </div>
                    </div>
                    </div>
                </div>`
        this.cartDrawerContent.innerHTML += o
    }

    formatMoney(t, e) {
        "string" === typeof t && (t = t.replace(".", ""));
        var r = "",
            o = /\{\{\s*(\w+)\s*\}\}/,
            n = e || a;

        function formatWithDelimiters(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2,
                r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ",",
                a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : ".";
            if (isNaN(t) || null == t) return 0;
            var o = (t = (t / 100).toFixed(e)).split(".");
            return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1".concat(r)) + (o[1] ? a + o[1] : "")
        }
        switch (n.match(o)[1]) {
            case "amount":
                r = formatWithDelimiters(t, 2);
                break;
            case "amount_no_decimals":
                r = formatWithDelimiters(t, 0);
                break;
            case "amount_with_comma_separator":
                r = formatWithDelimiters(t, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                r = formatWithDelimiters(t, 0, ".", ",")
        }
        return n.replace(o, r)
    }

    getDiscounts() {
        var discounts = []
        var total_price = this.cart_total_price
        if (total_price >= 160 && total_price < 240) {
            discounts.push({ "value": 5, "code": "5PERCENTOFF" })
        }
        else if (total_price >= 240 && total_price < 320) {
            discounts.push({ "value": 10, "code": "10PERCENTOFF" })
        }
        else if (total_price >= 320) {
            discounts.push({ "value": 15, "code": "15PERCENTOFF" })
        }

        if (this.is_subscribed) {
            discounts.push({ "value": 30, "code": "FIRSTORDER30" })
        }
        this.discounts = discounts
    }

    calcDiscounts() {
        var dsc = 0
        var code = ""
        var discounts = this.discounts
        if (discounts.length > 1) {
            for (let i = 0; i < discounts.length - 1; i++) {
                dsc += discounts[i].value + discounts[i + 1].value - (discounts[i].value * discounts[i + 1].value) / 100
                code += `${discounts[i + 1].code}%2B${discounts[i].code}`
            }
            return { "value": dsc, "code": code }
        }
        else if (discounts.length == 1) {
            return { "value": discounts[0].value, "code": discounts[0].code }
        }
        else {
            return { "value": 0, "code": '' }
        }
    }
}

